import { DashboardLayout } from '@/components/layout/DashboardLayout';
import LiquidityDashboard from '@/components/secondary/LiquidityDashboard';

export default function LiquidityDashboardPage() {
  return (
    <DashboardLayout>
      <LiquidityDashboard />
    </DashboardLayout>
  );
}
